<template>
  <v-card :elevation="elevation" :min-width="minWidth" rounded="10">
    <v-data-table
      :headers="headers"
      :items="items"
      :height="height"
      :loader-height="2"
      :mobile-breakpoint="0"
      :header-props="{sortIcon: null}"
      :disable-sort="disableSort"
      :custom-sort="() => items"
      :show-select="showSelect"
      :single-select="singleSelect"
      :loading="loading"
      checkbox-color="blue darken-1"
      hide-default-footer
      disable-pagination
      class="custom-table"
      :must-sort="!disableSort"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-if="isShowTotal && items.length && total" #[`body.prepend`]>
        <tr class="blueLight">
          <td v-if="xsOnly"></td>
          <td v-for="(td, i) in headers" :key="td.value" :class="[td.align ? 'text-' + td.align : '']">
            <div v-if="i === 0">
              {{ $t('table.total') }}
            </div>
            <div v-else-if="td.value === 'details'"></div>
            <div v-else class="width-m-content mx-auto">
              {{ !total[td.value] && total[td.value] !== 0 ? '-' : total[td.value] }}
            </div>
          </td>
        </tr>
      </template>
      <template v-for="th in headers" #[`header.${th.value}`]="{}">
        <div :key="th.value" class="custom-table__header">
          <v-icon v-if="th.headerIcon" size="40" disabled class="table-icon">{{ th.headerIcon }}</v-icon>
          <span v-else class="table-title" :class="th.class">{{ setTranslateTitle(th) }}</span>
          <v-btn
            v-if="th.isFilter && isPermission"
            icon
            small
            class="custom-table__filter"
            :class="th.value || th.headerIcon ? 'ml-2' : 'transform-left'"
            :color="checkActivated(selectedFilters, th.value) ? 'blue' : 'grey'"
            @click.stop="$emit('filterAction', th)"
          >
            <v-icon size="16"> mdi-filter-outline </v-icon>
          </v-btn>
        </div>
      </template>

      <v-progress-linear slot="progress" color="red" height="2" indeterminate />

      <template #no-data>
        <div class="d-flex justify-center py-8">
          <span class="font-18 font-weight-regular">{{ $t(noDataTitle) }}</span>
        </div>
      </template>

      <template #loading>
        <div class="d-flex justify-center py-8">
          <span class="font-18 font-weight-regular">{{ $t('table.loading') }}</span>
        </div>
      </template>

      <template #no-results>
        <div class="d-flex justify-center py-8">
          <span class="font-18 font-weight-regular">{{ $t('table.noResults') }}</span>
        </div>
      </template>

      <!--      <template #footer></template>-->

      <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />

      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {setTranslateTitle} from '@/helpers/table'

export default {
  name: 'CustomTable',
  inheritAttrs: false,
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Object,
      default: () => {},
    },
    selectedFilters: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => {},
    },
    disableSort: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: [Number, String],
      default: 1,
    },
    isPermission: {
      type: Boolean,
      default: false,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
    noDataTitle: {
      type: String,
      default: 'table.noData',
    },
    minWidth: {
      type: [Number, String],
      default: '',
    },
    height: {
      type: [Number, String],
      default: '',
    },
    isResetSortParams: {
      type: Boolean,
      default: false,
    },
    isShowTotal: {
      type: Boolean,
      default: false,
    },
    xsOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setTranslateTitle,
    checkActivated(filters, value) {
      return filters.some((a) => a.name === value)
    },
  },
  watch: {
    options: {
      deep: true,
      handler(sortOptions) {
        if (this.isResetSortParams) return

        if (sortOptions.sortBy.length) {
          this.$emit('changeSortParams', {
            sortNameParam: sortOptions.sortBy[0],
            sortSetParam: sortOptions.sortDesc[0] ? 'asc' : 'desc',
          })
        } else {
          this.$emit('changeSortParams', {
            sortNameParam: undefined,
            sortSetParam: undefined,
          })
        }
      },
    },
  },
}
</script>
<style lang="scss">
.custom-table {
  &.v-data-table {
    .v-data-table__wrapper {
      table {
        thead {
          tr {
            th.active.desc .table-title,
            th.active.desc .table-icon {
              color: var(--v-red-base) !important;
            }

            th.active.asc .table-title,
            th.active.asc .table-icon {
              color: var(--v-green-base) !important;
            }
          }
        }
      }
    }
  }

  &__header {
    position: relative;
  }

  &__filter {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;

    &.transform-left {
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
